import React, { memo } from 'react';
import cx from 'classnames';
// widgets
import DropdownOption from '../Option';
// styles
import styles from './Content.module.scss';
function DropDownContent({ options, renderFunction, closeMenu, onChange, className, }) {
    const onOptionSelect = (option) => {
        handleSingleSelect(option);
    };
    const handleSingleSelect = (option) => {
        const updatedOptions = [...options];
        for (const option of updatedOptions) {
            option.selected = false;
        }
        const index = updatedOptions.findIndex((i) => i.id === option.id);
        updatedOptions[index].selected = !updatedOptions[index].selected;
        onChange(updatedOptions);
        closeMenu();
    };
    return (React.createElement("div", { className: styles.containerWrapper },
        React.createElement("div", { className: cx(styles.containerWrapper, className) }, options.map((option, index) => {
            return (React.createElement(DropdownOption, { key: index, option: option, index: index, onOptionSelect: onOptionSelect, renderFunction: renderFunction }));
        }))));
}
export default memo(DropDownContent);
